import React from "react";
import { Routes } from "react-router-dom";
import { UserRoutes } from "./UserRoutes";
import { WebRoutes } from "./WebRoutes";
import { ArtistRoutes } from "./ArtistRoutes";
import { AdminRoutes } from "./AdminRoutes";
import { GoogleOAuthProvider } from '@react-oauth/google';

const AllRoutes = () => {
  return (
    <GoogleOAuthProvider clientId="1024397065742-770t4n8sk59vop3i6q2j7jfi2dck7969.apps.googleusercontent.com">
    <Routes>
      {WebRoutes()}
      {UserRoutes()}
      {ArtistRoutes()}
      {AdminRoutes()}
    </Routes>
    </GoogleOAuthProvider>
  );
};

export default AllRoutes;
